export default "__VITE_ASSET__BdN_g6P$__"